import React, { ReactElement } from 'react'
import TooltipTrigger from 'react-popper-tooltip'
import 'react-popper-tooltip/dist/styles.css'
import { ITooltip } from '../interfaces/Tooltip'

const Tooltip = ({
  tooltip,
  size,
  children,
  ...props
}: ITooltip): ReactElement => (
  <TooltipTrigger
    {...props}
    tooltip={({
      getTooltipProps,
      getArrowProps,
      tooltipRef,
      arrowRef,
      placement,
    }) => (
      <div
        {...getTooltipProps({
          ref: tooltipRef,
          className: `tooltipContainer ${
            size === 'tooltipContainerSmall'
              ? 'tooltipContainerSmall'
              : 'tooltipContainerLarge'
          }`,
        })}
      >
        <div className="tooltipContent">
          <div
            {...getArrowProps({
              ref: arrowRef,
              'data-placement': placement,
              className: 'tooltip-arrow tooltipArrow',
            })}
          />
          {tooltip}
        </div>
      </div>
    )}
  >
    {({ getTriggerProps, triggerRef }) => (
      <span
        {...getTriggerProps({
          ref: triggerRef,
          className: 'trigger',
        })}
      >
        {children}
      </span>
    )}
  </TooltipTrigger>
)

export default Tooltip
